import image from '@ingka/ssr-icon/paths/image';
import SSRIcon from '@skapa/SSRIcon';
import { clsx } from 'clsx';
import React from 'react';
import styles from './VisualPlaceholder.module.scss';

type VisualPlaceholderProps = {
    className?: string;
};

const VisualPlaceholder: React.FC<VisualPlaceholderProps> = ({ className }) => {
    return (
        <div className={clsx(styles.wrapper, className)}>
            <div className={styles.innerWrapper}>
                <SSRIcon paths={image} />
            </div>
        </div>
    );
};

export default VisualPlaceholder;
